/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, ProductCard } from '@coursera/cds-core';

import CompactCollectionHeadline from 'bundles/unified-common/components/compact-collection/CompactCollectionHeadline';

const styles = {
  container: css`
    /* CDS ProductCard style overrides */
    .cds-ProductCard-listSkeleton {
      flex-direction: row !important;
    }

    .cds-ProductCard-listSkeletonPreviewContainer {
      flex: unset !important;
    }

    .cds-ProductCard-listSkeleton .cds-ProductCard-listSkeletonPreview {
      height: var(--list-img-size) !important;
      width: var(--list-img-size) !important;
      aspect-ratio: unset !important;
    }
  `,
};

type Props = {
  headline?: string;
  headlineTarget?: string;
};

const CompactCollectionPlaceholder = ({ headline, headlineTarget }: Props) => {
  return (
    <div css={styles.container}>
      <CompactCollectionHeadline headline={headline} headlineTarget={headlineTarget} />
      <Grid container spacing={8}>
        {Array.from(Array(3).keys()).map((value) => (
          <Grid item xs={12} key={value}>
            <ProductCard variant="list" productType="role" loading={true} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CompactCollectionPlaceholder;
